/**
 * Application Management Page
 * Main page for managing member applications
 */

import React from 'react';
import { AdminRoute } from '../../components/auth/AdminRoute';
import ApplicationManagement from '../../components/applications/ApplicationManagement';

const ApplicationManagementPage = () => {
  return (
    <AdminRoute>
      <ApplicationManagement />
    </AdminRoute>
  );
};

export default ApplicationManagementPage;
